import React from 'react';
import './MarketplaceHeaderMolecule.scss';

export interface MarketplaceHeaderMoleculeLabels {
  title: string;
  subtitle: string;
  myChannels: string;
  newChannel: string;
  publishers?: string;
}

export interface MarketplaceHeaderMoleculeProps {
  labels: MarketplaceHeaderMoleculeLabels;
  myChannelsCount: number;
  myChannelsActive: boolean;
  onMyChannelsToggle: () => void;
  onNewChannelClick: () => void;
  onPublishersClick?: () => void;
  className?: string;
}

const MarketplaceHeaderMolecule: React.FC<MarketplaceHeaderMoleculeProps> = ({
  labels,
  myChannelsCount,
  myChannelsActive,
  onMyChannelsToggle,
  onNewChannelClick,
  onPublishersClick,
  className = '',
}) => {
  const classes = ['marketplace-marketplace-header', className]
    .filter(Boolean)
    .join(' ');

  const myChannelsClasses = [
    'marketplace-marketplace-header__my-channels',
    myChannelsActive ? 'marketplace-marketplace-header__my-channels--active' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <header className={classes}>
      <div className="marketplace-marketplace-header__text">
        <h1 className="marketplace-marketplace-header__title">{labels.title}</h1>
        <p className="marketplace-marketplace-header__subtitle">{labels.subtitle}</p>
      </div>

      <div className="marketplace-marketplace-header__actions">
        {labels.publishers && (
          <button
            type="button"
            className="marketplace-marketplace-header__publishers"
            onClick={onPublishersClick}
          >
            <i className="pi pi-users" aria-hidden="true" />
            <span>{labels.publishers}</span>
          </button>
        )}
        <button
          type="button"
          className={myChannelsClasses}
          aria-pressed={myChannelsActive}
          onClick={onMyChannelsToggle}
        >
          <span className="marketplace-marketplace-header__my-channels-label">
            {labels.myChannels}
          </span>
          <span
            className="marketplace-marketplace-header__my-channels-count"
            aria-hidden="true"
          >
            {myChannelsCount}
          </span>
        </button>
        <button
          type="button"
          className="marketplace-marketplace-header__new-channel"
          onClick={onNewChannelClick}
        >
          <i className="pi pi-plus" aria-hidden="true" />
          <span>{labels.newChannel}</span>
        </button>
      </div>
    </header>
  );
};

MarketplaceHeaderMolecule.displayName = 'MarketplaceHeaderMolecule';

export default MarketplaceHeaderMolecule;
